var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgActions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.421,
    height: 27,
    viewBox: "0 0 7.421 27"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-actions_svg__cls-2{fill:#fff;stroke:#009ceb;stroke-width:1.6px;stroke-linecap:round;stroke-linejoin:round}.kpmg-actions_svg__cls-3{stroke:none}.kpmg-actions_svg__cls-4{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-actions_svg__ICN_Actiuni_Enabled",
    transform: "translate(-1352 -330)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-actions_svg__Ellipse_154",
    "data-name": "Ellipse 154",
    transform: "translate(1352 330)",
    fill: "#fff",
    stroke: "#009ceb",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-actions_svg__cls-3",
    cx: 3.711,
    cy: 3.711,
    r: 3.711
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-actions_svg__cls-4",
    cx: 3.711,
    cy: 3.711,
    r: 2.911
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-actions_svg__Ellipse_155",
    "data-name": "Ellipse 155",
    className: "kpmg-actions_svg__cls-2",
    transform: "translate(1352 339.789)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-actions_svg__cls-3",
    cx: 3.711,
    cy: 3.711,
    r: 3.711
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-actions_svg__cls-4",
    cx: 3.711,
    cy: 3.711,
    r: 2.911
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-actions_svg__Ellipse_156",
    "data-name": "Ellipse 156",
    className: "kpmg-actions_svg__cls-2",
    transform: "translate(1352 349.579)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-actions_svg__cls-3",
    cx: 3.711,
    cy: 3.711,
    r: 3.711
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-actions_svg__cls-4",
    cx: 3.711,
    cy: 3.711,
    r: 2.911
  })))));
}

export default SvgKpmgActions;